// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.type_enum_a4d863f7 */
var TypeEnumA4d863f7;
(function (TypeEnumA4d863f7) {
    TypeEnumA4d863f7["Trace"] = "Trace";
    TypeEnumA4d863f7["Main Components"] = "Main Components";
    TypeEnumA4d863f7["Nutrient"] = "Nutrient";
})(TypeEnumA4d863f7 || (TypeEnumA4d863f7 = {}));
;
export default TypeEnumA4d863f7;
/** Zod schema for type_enum_a4d863f7 */
export const typeEnumA4d863f7 = z.nativeEnum(TypeEnumA4d863f7);
//# sourceMappingURL=TypeEnumA4d863f7.js.map